import React from 'react'
import '../../index.css'
import { Link } from "react-router";
import { Tooltip } from "react-tooltip";
import danites from '../../Assets/Img/danites.jpg'


const Chap24 = () => {
  return (
    <div className="chapter-container">

      <div className="chapterFooter">
        <Link to="/Chap23">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap25">Next</Link>
      </div>

      <h1 className='chapterHeading'>Chapter 24: Power and Violence</h1>

      <img src={danites} className='image' alt='Danites propositioning a woman' />

    <div className="wrapper">


    <div className='paragraph'>
          <p>As we have seen from their words and actions, the Council of Fifty was attempting to establish a very real, temporal 
            kingdom that would rule and reign over all the world’s governments. Daniel had prophesied, “Then shall the God of heaven 
            set up a kingdom, which shall never be destroyed: and the kingdom shall not be left to other people, but it shall break in 
            pieces and consume all these kingdoms, and it shall stand forever.”
            <btn id="clickable1" className="footnote">1 </btn>
            <Tooltip anchorSelect="#clickable1" className="footnote-size" clickable>Daniel 2:44.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Joseph and the Council of Fifty were planning a kingdom to which all nations would succumb as the Earth was cleansed to 
            prepare it for the Second Coming. Brigham Young stated in 1852, “The Lord God Almighty has set up a kingdom that will sway 
            the scepter of power and authority over all the kingdoms of the world, and will never be destroyed, it is the kingdom that 
            Daniel saw and wrote of. It may be considered treason to say that the kingdom which that Prophet foretold is actually set 
            up; … The kingdom will continue to increase, to grow, to spread and prosper more and more … and become more wonderful and 
            conspicuous to the nations, until it fills the whole earth.”
            <btn id="clickable2" className="footnote">2 </btn>
            <Tooltip anchorSelect="#clickable2" className="footnote-size" clickable>Brigham Young, Journal of Discourses, April 6, 1852, vol. 1, p. 202-203.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Until Christ arrived, Joseph was the King, and other Mormon leaders would rule under him. Speaking of the March 1844 
            meetings, in an 1886 revelation given to Mormon prophet John Taylor, “mention is made of Joseph Smith being crowned a king 
            in Nauvoo. Not only was he ordained a king, but leading members of the Church were assigned governmental responsibilities. 
            Brigham Young was to be president, John Taylor vice president, members of the Church were assigned to represent different 
            states in the house and senate of the United States, and a full cabinet was appointed.”
            <btn id="clickable3" className="footnote">3 </btn>
            <Tooltip anchorSelect="#clickable3" className="footnote-size" clickable>Diary of George A. Smith, May 9,1844, located in the Library of the Church Historian; Kenneth W. Godfrey, former director of the LDS Institute at Stanford University, BYU Studies, Winter 1968, p. 212-13, quoted in doctoral dissertation Causes of Mormon Non-Mormon Conflict in Hancock County, Illinois, 1839-1846, Ph.D. dissertation, BYU, 1967, pp. 63-65.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Brigham Young said, speaking of himself in the future, “In the free and independent government of the United States, 
            who in the eyes of the Almighty ought to have the privilege of sitting in the Presidential chair, to be countenanced, 
            adored, loved, and reverenced in his capacity, and be justified therein by the heavenly hosts? It is that man who is 
            sanctified before God, and who loves the Lord Jesus with all his heart, or in other words, who is endowed with wisdom 
            from on high, and has revelations, visions, and dreams.”
            <btn id="clickable4" className="footnote">4 </btn>
            <Tooltip anchorSelect="#clickable4" className="footnote-size" clickable>Brigham Young, Journal of Discourses, Feb. 18, 1855, vol. 2, p. 188-189.</Tooltip> 

          </p>
        </div>

        <h2 className="headlinePadding">Missouri Danites: The Nucleus of the Council of Fifty</h2>

        <div className='paragraph'>
          <p>In 1838 in Missouri – before the Mormons were expelled from the state – Joseph stated that he would be a second Mohammed 
            to this generation. “If the people will let us alone, we will preach our gospel in peace. But if they come on us to molest 
            us, we will establish our religion by the sword. We will trample down our enemies and make it one gore of blood from the 
            Rocky Mountains to the Atlantic Ocean. I will be to this generation a second Mohammed whose motto for treating for 
            peace ‘the Alcoran or the sword’ So shall it eventually be with us.”
            <btn id="clickable5" className="footnote">5 </btn>
            <Tooltip anchorSelect="#clickable5" className="footnote-size" clickable>Joseph Smith, speech given at Far West, Missouri, October 14, 1838.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>The violent Danites from the Missouri period of the church, with their secret oaths and penalties, were the organizing 
            nucleus of the Council of Fifty.  
            <btn id="clickable6" className="footnote">6 </btn>
            <Tooltip anchorSelect="#clickable6" className="footnote-size" clickable>Gentry, “Danite Band of 1838,” 431, and Hartley, My Best for the Kingdom, 50.</Tooltip> 

            As discussed earlier, in Missouri, Joseph encouraged the Mormons to not fear the Missourians. In a speech, Joseph 
            referred to Judges 18 about the tribe of Dan, “If the enemy comes, the Danites will be after them, meaning the brethren 
            in self-defense.”  
            <btn id="clickable7" className="footnote">7 </btn>
            <Tooltip anchorSelect="#clickable7" className="footnote-size" clickable>B.H. Roberts, “Chapter VII,” History of the Church of Jesus Christ of Latter-day Saints, vol. 6, pp. 155–180. 1912.</Tooltip> 
            
            Mormon Sampson Avard heard Joseph’s remarks and organized a vigilante group called the Danites. The Danites also referred to themselves as the Destroying Angels. Later, Sampson would testify in court that Joseph and the First Presidency sanctioned the Danites. Sampson also testified that he taught to rob and plunder the Missouri Gentiles, and that with their ill-gotten spoils the Kingdom of God would be built. 
          </p>
        </div>

        <h2 className="headlinePadding">Eighteen out of Fifty Former Danites</h2>

        <div className='paragraph'>
          <p>Eighteen former Danites made up one-third of the Council of Fifty. These were the same men who destroyed property, burned barns and farmhouses, and plundered items for the bishop’s storehouse. Naturally, Christ would choose these meek and lowly men to build his theocracy. 
          </p>
        </div>

        <div className='paragraph'>
          <p>Similar to Joseph’s temple endowment, the Council of Fifty initiation ceremony included keywords, passwords, obligation of 
            secrecy, and penalties. Historian Michael Quinn wrote, “Danites in 1838 emphasized the number fifty organizationally, took 
            oaths of secrecy, and saw their organization as implementing the Daniel prophecy for a latter-day kingdom of God. Since 
            Smith approved of the Danite organization until it was exposed in the courtroom and since he directly organized the 
            Council of Fifty, it is difficult to regard their similarities as mere coincidence.” 
            <btn id="clickable8" className="footnote">8 </btn>
            <Tooltip anchorSelect="#clickable8" className="footnote-size" clickable>Michael Quinn, The Mormon Hierarchy: Origins of Power, 1994, 129.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Speaking of penalties for oath-breaking, Orrin Porter Rockwell stated of the Council of Fifty, “those [who] leaked 
            out shall pay the forfeit by the loss of his head; if I find them.”  
            <btn id="clickable9" className="footnote">9 </btn>
            <Tooltip anchorSelect="#clickable9" className="footnote-size" clickable>Council of Fifty, Minutes, February 4, 1845, 224.</Tooltip> 
            
            Therefore, some members of the secretive, oath-bound Council of Fifty had histories of religious violence.
          </p>
        </div>

        <h2 className="headlinePadding">Gentiles’ Rejection of the Book of Mormon</h2>

        <div className='paragraph'>
          <p>Council of Fifty minutes highlight Joseph’s aims of using the Native Americans in his vision of building his theocratic 
            Kingdom of God. As mentioned earlier, the Book of Mormon discusses the Lamanites’ role in Joseph’s latter-day plans. 
            God had given Native Americans the land of America as a “land of their inheritance.”  
            <btn id="clickable10" className="footnote">10 </btn>
            <Tooltip anchorSelect="#clickable10" className="footnote-size" clickable>3 Nephi 20:14.</Tooltip> 

            It was the Lamanites’ work as descendants of the Tribe of Ephraim, to establish Zion, the New Jerusalem, on the American 
            continent in the last days. In the Americas Christ preached, “And behold, this people (future Lamanites) will I establish 
            in this land (America), unto the fulfilling of the covenant which I made with your father Jacob; and it shall be a New 
            Jerusalem. And the powers of heaven shall be in the midst of this people; yea, even I will be in the midst of you.”
            <btn id="clickable11" className="footnote">11 </btn>
            <Tooltip anchorSelect="#clickable11" className="footnote-size" clickable>3 Nephi 20:21–22.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Christ also preached a warning to the American Gentiles that if they did not accept his restored gospel, Mormonism, that 
            the latter-day Lamanites would destroy Gentiles. “And my people who are a remnant of Jacob shall be among the Gentiles … 
            as a lion among the beasts of the forest, as a young lion among the flocks of sheep, who, if he go through both treadeth 
            down and teareth in pieces, and none can deliver … Yea, wo be unto the Gentiles except they repent; for it shall come to 
            pass in that day, saith the Father, that I will cut off thy horses out of the midst of thee, and I will destroy thy 
            chariots; And I will cut off the cities of thy land, and throw down all thy strongholds ... And it shall come to pass, 
            saith the Father, that the sword of my justice shall hang over them (the Gentiles) at that day; and except they repent it 
            shall fall upon them.”
            <btn id="clickable12" className="footnote">12 </btn>
            <Tooltip anchorSelect="#clickable12" className="footnote-size" clickable>3 Ne. 20: 15-17, 20.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Speaking of the violence the Native Americans would inflict upon the unrepentant Gentiles (non-Mormons), Mormon apostle 
            Parley Pratt affirmed, “All who (Gentiles) will not hearken to the Book of Mormon, shall be cut off from among the people … 
            And not only does this set the time for the overthrow of our government and all other Gentile governments on the American 
            continent, but the way and means of this utter destruction are clearly foretold, namely, the remnant of Jacob (Native 
            Americans) will go through among the Gentiles and tear them in pieces, like a lion among the flocks of sheep … This 
            destruction includes an utter overthrow, and desolation of all our cities … an entire annihilation of our race, except … 
            are numbered with Israel.” 
            <btn id="clickable13" className="footnote">13 </btn>
            <Tooltip anchorSelect="#clickable13" className="footnote-size" clickable>Parley P. Pratt, Mormonism Unveiled: Zion’s Watchman Unmasked, 1838, 15. </Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Parley continued, “I will state as a prophecy, that there will not be an unbelieving Gentile upon this continent 50 years 
            hence, and if they are not greatly scourged, and in a great measure overthrown, within five or ten years from this date, 
            then the Book of Mormon will have proved itself false.”  
            <btn id="clickable14" className="footnote">14 </btn>
            <Tooltip anchorSelect="#clickable14" className="footnote-size" clickable>Parley P. Pratt, Mormonism Unveiled: Zion’s Watchman Unmasked, 1838, 15. </Tooltip> 
            
            Parley made these remarks in 1838. Fifty years later, by 1888, this prophecy was not fulfilled, and the Gentiles, as well as the U.S. government, escaped the wrath of the Mormon God.
          </p>
        </div>

        <div className='paragraph'>
          <p>Shortly after Joseph’s death, George Davis wrote that Joseph had met with the Native American tribes of Sacs and Foxes, 
            Sioux, and Pottawattamies: “The great aim of Joseph Smith was evidently to clothe himself with the most unlimited power, 
            civil, military and ecclesiastical over all who became members of his society.... [He stated] that God had revealed to him, 
            that the Indians and Latter-Day Saints, under Joseph as their King and Ruler, were to conquer the Gentiles, and that their 
            subjection to this authority was to be obtained by the sword! From this revelation, he enforced upon them that it was 
            necessary he should be crowned King, and…was accordingly CROWNED KING under God, over, the immediate house of Israel. 
            This ceremony was performed in 1842 [1844], by a council of fifty…. [That] the whole earth was to become under subjection 
            to him…. accordingly, Joseph swore them all to present secrecy, under the penalty of death. It is also a fact, ascertained 
            beyond controversy, that the Indian tribes of Sacs and Foxes, Sioux’s and Pottawattamies, were consulted, and their assent 
            obtained previous to the mock crowning…and that delegates were sent to Nauvoo from each of the above tribes about the time 
            of the ceremony being performed [on April 11, 1844], by the council of fifty. These delegations of Indians were seen by 
            hundreds and hundreds at Nauvoo, but the object of their visitation never was ascertained without the pale of the church, 
            until secessions commenced taking place from the Mormons. The reader may naturally inquire how these facts have been ascertained. 
            I state, from the only source possible to derive information; that is, from those who aided in the ceremony, but who have since 
            returned to their reason and come out from among this den of wicked and perverse men.” 
            <btn id="clickable15" className="footnote">15 </btn>
            <Tooltip anchorSelect="#clickable15" className="footnote-size" clickable>Geo. T. M. Davis, An Authentic Account of the Massacre of Joseph Smith, The Mormon Prophet and Hyrum Smith, His Brother, together with a brief history of the rise and progress of Mormonism, and all the circumstances which led to their death, 7-8.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>In the spring of 1844, Joseph sent Council of Fifty members, Alpheus Cutler and Lewis Dana, an Oneida Indian, to the 
            Lamanite ministries.  
            <btn id="clickable16" className="footnote">16 </btn>
            <Tooltip anchorSelect="#clickable16" className="footnote-size" clickable>Michael Quinn, The Mormon Hierarchy: Origins of Power, 1994, 179-80, 209, 529. </Tooltip> 

            Joseph charged Cutler with restoring the Lamanites to Zion. Cutler and his missionaries sought proselytes among the Oneida, 
            Delaware, and probably Shawnee tribes in the Kansas and Missouri area.  
            <btn id="clickable17" className="footnote">17 </btn>
            <Tooltip anchorSelect="#clickable17" className="footnote-size" clickable>Danny Jorgensen, “Building the Kingdom of God: Alpheus Cutler and the Second Mormon Mission to the Indians, 1846-1853,” Kansas History 15, no. 3 (1992): 192, 209; and Danny L. Jorgensen, “The Old Fox: Alpheus Cutler,” in Differing Visions: Dissenters in Mormon History, ed. Roger D. Launius and Linda Thatcher, 1994, 161, 165.</Tooltip> 

            Also in 1844, Joseph sent Lyman Wight and George Miller to Texas in 1844 to preach to Native Americans. Wight stated, 
            “Instruction was given me by brother Joseph with great zeal; setting forth the necessity for such a mission, for the good 
            of the cause of bringing the Lamanites to the knowledge of the truth, paving the way for the redemption of Zion and building 
            the Temple in Jackson County.”
            <btn id="clickable18" className="footnote">18 </btn>
            <Tooltip anchorSelect="#clickable18" className="footnote-size" clickable>Letter of Lyman Wight on 29 November 1844. An Address by Way of an Abridged Account and Journal of My Life from February 1844 up to April 1848, with An Appeal to the Latter-Day Saints ([Austin, TX], 1848), 5-6.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Were these simple missionary activities attempting to convert the Native Americans to Mormonism and restoring them to the knowledge of their identity as members of the House of Israel? Or was there something more sinister? Were the missions attempts to recruit the Native Americans to fulfill the Book of Mormon mandate for destroying the non-converted Gentiles?
          </p>
        </div>

        <div className='paragraph'>
          <p>John Putnam swore in an affidavit that “… the Mormons are endeavoring to seduce the Indian tribes from their allegiance 
            to the United States and engage them to take up the hatchet against the people of the United States, and that white men are 
            to lead them on to the conflict.” He further stated, “… that he has understood that Lyman Wight has already departed 
            [to Texas] to stir up the savages and prepare them for the final struggle with the whites.”
            <btn id="clickable19" className="footnote">19 </btn>
            <Tooltip anchorSelect="#clickable19" className="footnote-size" clickable>Affidavit of John W. Putnam, August 13, 1844, published in “Letters to Gov. Ford−No. IV,” Alton Telegraph & Democratic Review, March 15, 1845, 1.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Wilson Law, brother of First Presidency Counselor William Law, swore in an affidavit of June 20, 1844, that Joseph was 
            ready to “Set the laws at defiance; for the Government, he said, was corrupt, and ought to be overthrown, and he would 
            do it, for he could get help plenty from the Indians, for he had communication with them all the time, and they were ready … 
            And further, that Hyrum Smith, last winter, said to the affiant, that this Government must be changed; for it did not 
            suit them, and they could never keep the revelations or build up the kingdom under the present form of Government.”
            <btn id="clickable20" className="footnote">20 </btn>
            <Tooltip anchorSelect="#clickable20" className="footnote-size" clickable>Affidavit of Wilson Law, June 20, 1844, published in “Letters to Gov. Ford−No. II,” Alton Telegraph & Democratic Review, February 22, 1845, 1.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Plans involving Native Americans continued after Joseph Smith's death. Under Brigham Young’s leadership, by December 1847, 
            Council of Fifty member Alpheus Cutler was “recruiting portions of the six nations to the Delaware reserve … enlisting 
            the Indians in armed resistance against federal authorities.” Cutler was confident that “several thousand Indians along 
            the Missouri River could be marshaled into some kind of army of redemption. Such a force could level Fort Leavenworth 
            [Kansas] in six hours.” 
            <btn id="clickable21" className="footnote">21 </btn>
            <Tooltip anchorSelect="#clickable21" className="footnote-size" clickable>Jorgensen, “Building the Kingdom of God,” 200, 209; and Jorgensen, “The Old Fox,” 164.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>By 1849, Orson Hyde reported that Cutler was organizing the American Indians for armed rebellion, attempting to 
            reestablish the church in Jackson County, and restoring the Lamanites to Zion.  
            <btn id="clickable22" className="footnote">22 </btn>
            <Tooltip anchorSelect="#clickable22" className="footnote-size" clickable>Jorgensen, “Building the Kingdom of God,” 201 fn27; and Jorgensen, “The Old Fox,” 166-67; see also, Orson Hyde, George A. Smith, and Ezra T. Benson, “A Report to Presidents Brigham Young, Heber C. Kimball, Willard Richards, and the Authorities of the Church of the Jesus Christ of Latter-Day Saints in Zion,” 1849, 16-24, Brigham Young Collection, LDS Church History Library.</Tooltip> 
            
            Council of Fifty minutes state in 1849, “A union has been formed with 37 Indian nations and like the state of Greece by 
            Alexander the Great they have elected Father Cutler as generalissimo of the confederacy. Father Cutler’s trowel is going 
            to ring on the temple walls in Jackson County in a few days. The remnants of Jacob are going to slay and go through, 
            tear down, break-in pieces, and none can deliver. I tell you it is a great deal closer than anybody thinks. Father Cutler 
            has done a great work than any other man since the days of Jesus Christ.” 
            <btn id="clickable23" className="footnote">23 </btn>
            <Tooltip anchorSelect="#clickable23" className="footnote-size" clickable>Orson Hyde, George A. Smith, and Ezra T. Benson, “Report to Brigham Young and Council of Twelve,” 14 March-5 April 1849, 14, Brigham Young Correspondence, LDS Church Archives.</Tooltip> 

          </p>
        </div>

        <div className='paragraph'>
          <p>Fortunately, none of these efforts came to pass.
          </p>
        </div>

        <h2 className="headlinePadding">Theocratic Satellite Cells</h2>

        <div className='paragraph'>
          <p>Under Joseph’s direction, members of the Council of Fifty were sent to different parts of the world. They were sent on 
            missions for the church, but these most likely were cover for theocratic satellite cells to create influence for the Kingdom 
            of God. On 13 March 1844, Council of Fifty member Amos Fielding was sent to England. Joseph signed a certificate for Amos 
            to “transact such business as may be deemed necessary for the benefit of said Church.” British influence was crucial for 
            establishing Mormon colonies in both Texas and Oregon. “British officers are now running all over Texas to establish 
            British influence in that country,” Joseph said in March 1844.
            <btn id="clickable24" className="footnote">24 </btn>
            <Tooltip anchorSelect="#clickable24" className="footnote-size" clickable>History of the Church, 6:369.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>On June 7, 1844, Joseph signed a missionary certificate for Council of Fifty member George Adams “to the empire of Russia.” 
            This appeared to be a reinstatement of an earlier assignment for Adams to proselytize in Russia. Council of Fifty member 
            Almon Babbitt reported to the council that “the Russian Mission was connected with Uriah Brown’s invention to destroy 
            an army or navy.” Before the council’s formation, Joseph and Hyrum explained that the proposed mission to Russia involved 
            “some of the most important things concerning the advancement and building up of the kingdom of God in the last days, 
            which cannot be explained at this time.” Like the certificate to Amos Fielding three months earlier, George Adams’s 
            written commission provided a ministerial cover for a theocratic ambassador.
            <btn id="clickable25" className="footnote">25 </btn>
            <Tooltip anchorSelect="#clickable25" className="footnote-size" clickable>Michael Quinn, The Mormon Hierarchy: Origins of Power, 1994, 132.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Historian Michael Quinn wrote, “For nearly five years Smith had played the Whigs against the Democrats to benefit Mormons 
            at Nauvoo. Now he intended to exploit international rivalries on behalf of Mormons. He prepared to establish large Mormon 
            settlements in the Republic of Texas (unrecognized by Mexico and coveted by the United States, Britain, and France), in 
            Oregon (disputed by the U.S., England, and Russia), and in California (settled by Mexico and coveted by both France and 
            the United States). This was a dangerous game.”
            <btn id="clickable26" className="footnote">26 </btn>
            <Tooltip anchorSelect="#clickable26" className="footnote-size" clickable>Michael Quinn, The Mormon Hierarchy: Origins of Power, 1994, 134.</Tooltip> 
          </p>
        </div>

        </div> 

      <div className="chapterFooter">
        <Link to="/Chap23">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap25">Next</Link>
      </div>

    </div>
  )
}

export default Chap24